import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import App from './App.jsx';

hydrateRoot(
    document.getElementById('root'),
    <React.StrictMode>
        <App initialData={window.__HOOSHPAZ_DATA__ || null} />
    </React.StrictMode>
);
